// Freya & Fleur — scroll reveal (IntersectionObserver)
(function () {
  function init() {
    var els = document.querySelectorAll('.ff-reveal');
    if (!('IntersectionObserver' in window) || !els.length) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }
  // Shoppable hotspot: nokta tıkla → fiyat kartı
  function hotspots() {
    document.querySelectorAll('.ff-hotspot__dot').forEach(function (dot) {
      if (dot.dataset.ffBound) return;
      dot.dataset.ffBound = '1';
      dot.addEventListener('click', function (e) {
        e.stopPropagation();
        var spot = dot.closest('.ff-hotspot');
        var open = spot.classList.contains('is-open');
        document.querySelectorAll('.ff-hotspot.is-open').forEach(function (s) {
          s.classList.remove('is-open');
          s.querySelectorAll('video').forEach(function (v) { v.pause(); });
        });
        if (!open) {
          spot.classList.add('is-open');
          spot.querySelectorAll('video').forEach(function (v) {
            v.muted = true;
            v.dataset.ffInView = '1';
            var p = v.play(); if (p && p.catch) p.catch(function () {});
          });
        }
      });
    });
  }
  function closeAll() {
    document.querySelectorAll('.ff-hotspot.is-open').forEach(function (s) {
      s.classList.remove('is-open');
      s.querySelectorAll('video').forEach(function (v) { v.pause(); });
    });
    document.querySelectorAll('.ff-qa.is-open').forEach(function (c) { c.classList.remove('is-open'); });
  }

  // Banner slider
  function sliders() {
    document.querySelectorAll('.ff-slider').forEach(function (sl) {
      if (sl.dataset.ffSlider) return;
      var track = sl.querySelector('.ff-slider__track');
      var slides = sl.querySelectorAll('.ff-slide');
      if (!track || slides.length < 2) { return; }
      sl.dataset.ffSlider = '1';
      var dotsWrap = sl.querySelector('.ff-slider__dots');
      var i = 0, n = slides.length, timer = null;
      var delay = parseInt(sl.dataset.autoplay, 10) || 0;

      var dots = [];
      if (dotsWrap) {
        for (var d = 0; d < n; d++) {
          var b = document.createElement('button');
          b.setAttribute('aria-label', 'Slayt ' + (d + 1));
          (function (idx) { b.addEventListener('click', function () { go(idx); }); })(d);
          dotsWrap.appendChild(b); dots.push(b);
        }
      }
      function render() {
        track.style.transform = 'translateX(' + (-i * 100) + '%)';
        dots.forEach(function (dt, k) { dt.classList.toggle('is-active', k === i); });
      }
      function go(idx) { i = (idx + n) % n; render(); restart(); }
      function next() { go(i + 1); }
      function prev() { go(i - 1); }
      function restart() { if (!delay) return; clearInterval(timer); timer = setInterval(next, delay); }

      var pv = sl.querySelector('.ff-slider__arrow--prev');
      var nx = sl.querySelector('.ff-slider__arrow--next');
      if (pv) pv.addEventListener('click', prev);
      if (nx) nx.addEventListener('click', next);
      sl.addEventListener('mouseenter', function () { clearInterval(timer); });
      sl.addEventListener('mouseleave', restart);

      // dokunmatik swipe
      var sx = null;
      track.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      track.addEventListener('touchend', function (e) {
        if (sx === null) return;
        var dx = e.changedTouches[0].clientX - sx;
        if (dx > 45) prev(); else if (dx < -45) next();
        sx = null;
      });

      render(); restart();
    });
  }

  // Ürün slider okları
  function prows() {
    document.querySelectorAll('.ff-prow-wrap').forEach(function (wrap) {
      if (wrap.dataset.ffProw) return; wrap.dataset.ffProw = '1';
      var row = wrap.querySelector('.ff-prow');
      if (!row) return;
      wrap.querySelectorAll('.ff-prow-arrow').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var card = row.querySelector('.ff-card');
          if (!card) return;
          var cs = getComputedStyle(row);
          var gap = parseFloat(cs.columnGap || cs.gap) || 16;
          var w = card.getBoundingClientRect().width + gap;
          // Mobilde tam 1 kart, genis ekranda gorunen kart sayisi kadar ilerle
          var per = window.innerWidth <= 749 ? 1 : Math.max(1, Math.floor(row.clientWidth / w));
          row.scrollBy({ left: (parseInt(btn.dataset.dir, 10) || 1) * w * per, behavior: 'smooth' });
        });
      });
      // kayan çubuk (scroll ilerleme)
      var bar = wrap.querySelector('.ff-prow-bar span');
      if (bar) {
        var upd = function () {
          var vis = Math.max(12, (row.clientWidth / row.scrollWidth) * 100);
          var maxScroll = row.scrollWidth - row.clientWidth;
          var ratio = maxScroll > 0 ? row.scrollLeft / maxScroll : 0;
          bar.style.width = vis + '%';
          bar.style.left = (ratio * (100 - vis)) + '%';
        };
        row.addEventListener('scroll', upd, { passive: true });
        window.addEventListener('resize', upd);
        upd();
      }
    });
  }

  // Animasyonlu arama placeholder (yaz + sil)
  function typeSearch() {
    document.querySelectorAll('.ff-search__input[data-typed]').forEach(function (inp) {
      if (inp.dataset.tw) return; inp.dataset.tw = '1';
      var words;
      try { words = JSON.parse(inp.getAttribute('data-typed')); } catch (e) { words = ['ara...']; }
      if (!words || !words.length) return;
      var wi = 0, ci = 0, deleting = false, paused = false;
      inp.addEventListener('focus', function () { paused = true; inp.placeholder = 'Ürün ara...'; });
      inp.addEventListener('blur', function () { if (!inp.value) { paused = false; tick(); } });
      function tick() {
        if (paused || inp.value) return;
        var w = words[wi];
        if (!deleting) { ci++; }
        else { ci--; if (ci <= 0) { deleting = false; wi = (wi + 1) % words.length; } }
        inp.placeholder = w.slice(0, ci) + '│';
        if (!deleting && ci >= w.length) { deleting = true; setTimeout(tick, 1600); return; }
        setTimeout(tick, deleting ? 45 : 95);
      }
      tick();
    });
  }

  // Fotoğraf hover-scrub: mouse sağa-sola → 2./3. fotoğraf
  function photoScrub() {
    document.querySelectorAll('.ff-pg-card__media').forEach(function (m) {
      if (m.dataset.ps) return; m.dataset.ps = '1';
      var n = parseInt(m.dataset.count, 10) || 1;
      if (n < 2) return;
      var imgs = m.querySelectorAll('.ff-pg-card__img');
      var bars = m.querySelectorAll('.ff-pg-card__bars span');
      var cur = -1;
      function set(idx) {
        if (idx === cur) return; cur = idx;
        imgs.forEach(function (im, i) { im.classList.toggle('is-on', i === idx); });
        bars.forEach(function (b, i) { b.classList.toggle('on', i === idx); });
      }
      m.addEventListener('mousemove', function (e) {
        var r = m.getBoundingClientRect();
        var ratio = (e.clientX - r.left) / r.width;
        set(Math.min(n - 1, Math.max(0, Math.floor(ratio * n))));
      });
      m.addEventListener('mouseleave', function () { set(0); });
      m.addEventListener('touchstart', function (e) {
        var r = m.getBoundingClientRect();
        var ratio = (e.touches[0].clientX - r.left) / r.width;
        set(Math.min(n - 1, Math.max(0, Math.floor(ratio * n))));
      }, { passive: true });
    });
  }

  // Shop the Look: hızlı ekle (+) → beden → sepete ekle
  function ffToast(msg) {
    var t = document.querySelector('.ff-toast');
    if (!t) { t = document.createElement('div'); t.className = 'ff-toast'; document.body.appendChild(t); }
    t.textContent = msg; t.classList.add('is-on');
    clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('is-on'); }, 2200);
  }
  // Sepet rozeti. DİKKAT: header.liquid rozeti sepet BOŞKEN hiç basmıyor
  // ({% if cart != empty %}), yani ilk eklemede güncellenecek bir düğüm YOK.
  // Bu yüzden yoksa oluşturuyoruz; sayı 0'a düşerse kaldırıyoruz.
  function cartAnchors() {
    var list = [].slice.call(document.querySelectorAll('#cart-icon-bubble, .header__icon--cart'));
    return list.filter(function (a, i) { return list.indexOf(a) === i; });
  }
  function paintCartCount(n) {
    cartAnchors().forEach(function (a) {
      var b = a.querySelector('.cart-count-bubble');
      if (!n) { if (b) b.remove(); return; }
      if (!b) {
        b = document.createElement('div');
        b.className = 'cart-count-bubble';
        b.innerHTML = '<span aria-hidden="true"></span><span class="visually-hidden"></span>';
        a.appendChild(b);
      }
      b.style.display = '';
      var num = b.querySelector('span[aria-hidden="true"]');
      if (!num) { num = document.createElement('span'); num.setAttribute('aria-hidden', 'true'); b.insertBefore(num, b.firstChild); }
      num.textContent = n < 100 ? n : '';
      var sr = b.querySelector('.visually-hidden');
      if (sr) sr.textContent = 'Sepette ' + n + ' ürün';
    });
  }
  function updateCartCount() {
    // Section Rendering API: rozet + dolu/boş sepet simgesi tek seferde doğru gelir.
    fetch('/?section_id=cart-icon-bubble').then(function (r) {
      if (!r.ok) throw 0; return r.text();
    }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var src = doc.querySelector('.shopify-section') || doc.body;
      if (!src || !src.innerHTML.trim()) throw 0;
      cartAnchors().forEach(function (a) { a.innerHTML = src.innerHTML; });
    }).catch(function () {
      // Yedek yol: sadece sayıyı /cart.js'ten al.
      return fetch('/cart.js').then(function (r) { return r.json(); })
        .then(function (c) { paintCartCount(c.item_count); });
    }).catch(function () {});
  }
  function quickAdd() {
    document.querySelectorAll('.ff-qa__btn').forEach(function (b) {
      if (b.dataset.qa) return; b.dataset.qa = '1';
      b.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var card = b.closest('.ff-qa'); var open = card.classList.contains('is-open');
        document.querySelectorAll('.ff-qa.is-open').forEach(function (c) { c.classList.remove('is-open'); });
        if (!open) card.classList.add('is-open');
      });
    });
    document.querySelectorAll('.ff-qa__x').forEach(function (x) {
      if (x.dataset.qa) return; x.dataset.qa = '1';
      x.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); x.closest('.ff-qa').classList.remove('is-open'); });
    });
    document.querySelectorAll('.ff-qa__size').forEach(function (s) {
      if (s.dataset.qa || s.disabled) return; s.dataset.qa = '1';
      s.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var id = s.getAttribute('data-id'); if (!id) return;
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] }) })
          .then(function (r) { return r.json(); })
          .then(function () { s.closest('.ff-qa').classList.remove('is-open'); ffToast('Sepete eklendi ✓'); updateCartCount(); })
          .catch(function () { ffToast('Eklenemedi, tekrar dene'); });
      });
    });
    document.querySelectorAll('.ff-sl__arrow').forEach(function (a) {
      if (a.dataset.qa) return; a.dataset.qa = '1';
      a.addEventListener('click', function () {
        var row = a.closest('.ff-sl__rowwrap').querySelector('.ff-sl__row');
        var card = row.querySelector('.ff-sl-card'); var w = card ? card.getBoundingClientRect().width + 16 : 220;
        row.scrollBy({ left: (parseInt(a.dataset.dir, 10) || 1) * w * 2, behavior: 'smooth' });
      });
    });
  }

  // Koleksiyon grid: favori kalpler (localStorage) + filtre otomatik uygula + dropdown kapat
  function collGrid() {
    var KEY = 'ff_wish';
    function wishes() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
    document.querySelectorAll('.ff-cg__wish[data-wish]').forEach(function (b) {
      if (b.dataset.w) return; b.dataset.w = '1';
      var h = b.getAttribute('data-wish');
      if (wishes().indexOf(h) > -1) b.classList.add('is-on');
      b.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var list = wishes(); var i = list.indexOf(h);
        if (i > -1) { list.splice(i, 1); b.classList.remove('is-on'); ffToast('Favorilerden çıkarıldı'); }
        else { list.push(h); b.classList.add('is-on'); ffToast('Favorilere eklendi ❤'); }
        try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e2) {}
      });
    });
    var form = document.getElementById('ff-cg-form');
    if (form && !form.dataset.cg) {
      form.dataset.cg = '1';
      form.addEventListener('change', function (e) {
        if (e.target.closest('.ff-flt--client')) return;
        if (e.target.matches('input[type="checkbox"], select')) form.submit();
      });
      document.addEventListener('click', function (e) {
        if (!e.target.closest('.ff-flt')) form.querySelectorAll('.ff-flt[open]').forEach(function (d) { d.removeAttribute('open'); });
        var pr = e.target.closest('.ff-flt__preset');
        if (pr) {
          var pop = pr.closest('.ff-flt__pop');
          pop.querySelector('.ff-flt__min').value = '';
          pop.querySelector('.ff-flt__max').value = pr.getAttribute('data-max');
          form.submit();
        }
        var cl = e.target.closest('.ff-flt__clearp');
        if (cl) {
          var pop2 = cl.closest('.ff-flt__pop');
          pop2.querySelector('.ff-flt__min').value = '';
          pop2.querySelector('.ff-flt__max').value = '';
          form.submit();
        }
        var cp = e.target.closest('[data-copylink]');
        if (cp) {
          var done = function () { ffToast('Link kopyalandı ✓'); };
          if (navigator.clipboard) navigator.clipboard.writeText(location.href).then(done).catch(function () { ffToast('Kopyalanamadı'); });
          else { ffToast('Kopyalanamadı'); }
          cp.closest('.ff-flt').removeAttribute('open');
        }
        var vt = e.target.closest('[data-viewtoggle]');
        if (vt) {
          var g = document.querySelector('.ff-cg__grid');
          if (g) {
            g.classList.toggle('is-loose');
            try { localStorage.setItem('ff_view', g.classList.contains('is-loose') ? '3' : '4'); } catch (e2) {}
          }
        }
      });
    }
    var g0 = document.querySelector('.ff-cg__grid');
    if (g0) { try { if (localStorage.getItem('ff_view') === '3') g0.classList.add('is-loose'); } catch (e3) {} }

    // Ürün seçeneklerinden (Beden, Renk...) otomatik istemci-taraflı filtre dropdownları
    var fwrap = document.querySelector('.ff-cg__filters');
    if (fwrap && !fwrap.dataset.cf) {
      fwrap.dataset.cf = '1';
      var cards = Array.prototype.slice.call(document.querySelectorAll('.ff-cg__card[data-fopts]'));
      function parseOpts(str) {
        var out = {};
        (str || '').split(';').forEach(function (part) {
          if (!part) return;
          var kv = part.split(':'); if (kv.length < 2) return;
          out[kv[0].trim()] = kv[1].split(',').map(function (x) { return x.trim(); });
        });
        return out;
      }
      var groups = {};
      cards.forEach(function (c) {
        var o = parseOpts(c.getAttribute('data-fopts'));
        Object.keys(o).forEach(function (name) {
          groups[name] = groups[name] || {};
          o[name].forEach(function (v) { groups[name][v] = (groups[name][v] || 0) + 1; });
        });
      });
      var existing = Array.prototype.map.call(fwrap.querySelectorAll('.ff-flt > summary'), function (s) { return s.textContent.trim().toLowerCase(); });
      Object.keys(groups).forEach(function (name) {
        if (existing.some(function (t) { return t.indexOf(name.toLowerCase()) === 0; })) return;
        var d = document.createElement('details');
        d.className = 'ff-flt ff-flt--client';
        var html = '<summary>' + name + ' <b>▾</b></summary><div class="ff-flt__pop">';
        Object.keys(groups[name]).forEach(function (v) {
          html += '<label class="ff-flt__opt"><input type="checkbox" data-fname="' + name + '" value="' + v.replace(/"/g, '&quot;') + '"><span>' + v + '</span><em>' + groups[name][v] + '</em></label>';
        });
        d.innerHTML = html + '</div>';
        fwrap.appendChild(d);
      });
      function applyClientFilters() {
        var active = {};
        fwrap.querySelectorAll('.ff-flt--client input:checked').forEach(function (i) {
          var n = i.getAttribute('data-fname');
          (active[n] = active[n] || []).push(i.value);
        });
        var shown = 0;
        cards.forEach(function (c) {
          var o = parseOpts(c.getAttribute('data-fopts'));
          var ok = Object.keys(active).every(function (n) {
            return (o[n] || []).some(function (v) { return active[n].indexOf(v) > -1; });
          });
          c.style.display = ok ? '' : 'none';
          if (ok) shown++;
        });
        var cnt = document.querySelector('.ff-cg__count');
        if (cnt) cnt.textContent = shown + ' ürün listeleniyor';
      }
      fwrap.addEventListener('change', function (e) {
        if (e.target.closest('.ff-flt--client')) applyClientFilters();
      });
    }
  }

  // ═══════ Ürün detay sayfası (PDP) ═══════
  function pdp() {
    var dataEl = document.getElementById('ff-pdp-data');
    // Kampanya iniş sayfası da bu bloğu kullanıyor (sihirbaz + beden çipleri):
    // orada .ff-pdp yerine [data-pdp-root] var.
    var root = document.querySelector('.ff-pdp, [data-pdp-root]');
    if (!dataEl || !root || root.dataset.pdp) return;
    root.dataset.pdp = '1';
    var P = JSON.parse(dataEl.textContent);
    function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    function fmt(cents) { return (cents / 100).toLocaleString('tr-TR', { minimumFractionDigits: 2 }) + ' TL'; }
    function closeModals() { document.querySelectorAll('.ff-modal.is-open').forEach(function (m) { m.classList.remove('is-open'); }); document.body.classList.remove('ff-lock'); }

    // Modal aç/kapat
    document.addEventListener('click', function (e) {
      var op = e.target.closest('[data-open]');
      if (op) {
        e.preventDefault();
        var m = document.querySelector(op.getAttribute('data-open'));
        if (m) {
          closeModals();
          m.classList.add('is-open'); document.body.classList.add('ff-lock');
          var t = op.getAttribute('data-tab'); if (t) wtab(t);
        }
        return;
      }
      if (e.target.closest('[data-close]')) closeModals();
      var tl = e.target.closest('[data-wtab-link]');
      if (tl) { e.preventDefault(); wtab(tl.getAttribute('data-wtab-link')); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModals(); });

    // Açıklama: daha fazla/az
    var moreBtn = document.querySelector('[data-descmore]');
    var descBody = document.querySelector('[data-desc]');
    if (moreBtn && descBody) {
      if (descBody.scrollHeight <= 100) moreBtn.style.display = 'none';
      moreBtn.addEventListener('click', function () {
        var open = descBody.classList.toggle('is-open');
        moreBtn.textContent = open ? 'Daha az' : 'Daha fazla';
      });
    }

    function addToCart(vid, done, fail) {
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: parseInt(vid, 10), quantity: 1 }] }) })
        .then(function (r) { if (!r.ok) throw 0; return r.json(); })
        .then(function () { ffToast('Sepete eklendi ✓'); updateCartCount(); done && done(); })
        .catch(function () { ffToast('Eklenemedi, tekrar dene'); fail && fail(); });
    }

    // Galeri: küçük fotoğrafa tıklayınca ana fotoğrafı değiştir.
    // Video medya da thumb olarak gelir (data-gtype="video") — seçilince ana alanda oynatılır.
    var gmain = document.querySelector('[data-gmain]');
    var gvid = document.querySelector('[data-gvideo]');
    function ffShowImage(src) {
      if (gvid) { try { gvid.pause(); } catch (e) {} gvid.removeAttribute('src'); gvid.load(); gvid.hidden = true; }
      gmain.hidden = false;
      gmain.classList.remove('is-swap');
      gmain.src = src;
      void gmain.offsetWidth; gmain.classList.add('is-swap');
    }
    function ffShowVideo(src, poster) {
      if (!gvid) { ffShowImage(poster); return; }
      gmain.hidden = true;
      gvid.hidden = false;
      if (poster) gvid.poster = poster;
      gvid.src = src;
      gvid.classList.remove('is-swap'); void gvid.offsetWidth; gvid.classList.add('is-swap');
      // sesli otomatik oynatmaya tarayıcı izin vermiyor — sessiz başlat, kullanıcı kontrolden açar
      gvid.muted = true;
      var p = gvid.play();
      if (p && p.catch) p.catch(function () {});
    }
    if (gmain) document.querySelectorAll('.ff-pdp__thumb').forEach(function (t) {
      t.addEventListener('click', function () {
        if (t.classList.contains('is-on')) return;
        document.querySelectorAll('.ff-pdp__thumb').forEach(function (x) { x.classList.remove('is-on'); });
        t.classList.add('is-on');
        if (t.getAttribute('data-gtype') === 'video') ffShowVideo(t.getAttribute('data-gvsrc'), t.getAttribute('data-gsrc'));
        else ffShowImage(t.getAttribute('data-gsrc'));
      });
    });
    // İlk medya video ise sayfa açılır açılmaz oynasın
    (function () {
      var ilk = document.querySelector('.ff-pdp__thumb.is-on[data-gtype="video"]');
      if (ilk) ffShowVideo(ilk.getAttribute('data-gvsrc'), ilk.getAttribute('data-gsrc'));
    })();

    // Beden seçimi — sayfadaki satır içi çipler VE beden paneli birlikte çalışır.
    // Aynı bedeni iki yerde de işaretlediğimiz için hangisi kullanılırsa kullanılsın senkron kalır.
    var selVid = null;
    var addBtns = [].slice.call(document.querySelectorAll('[data-sizeadd]'));
    var sizeBtns = [].slice.call(document.querySelectorAll('[data-sizes] .ff-size'));

    // Tek varyantlı üründe beden seçimi yok: varyantı doğrudan butondan al
    addBtns.forEach(function (b) { var v = b.getAttribute('data-vid'); if (v) selVid = v; });

    function pickSize(vid) {
      selVid = vid;
      sizeBtns.forEach(function (x) { x.classList.toggle('is-sel', x.getAttribute('data-vid') === vid); });
      addBtns.forEach(function (b) { b.disabled = false; });
    }
    sizeBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.disabled) return;
        pickSize(b.getAttribute('data-vid'));
      });
    });

    addBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!selVid) return;
        var t = btn.querySelector('[data-addtxt]') || btn;
        var old = t.textContent;
        btn.disabled = true;
        t.textContent = 'Ekleniyor…';
        addToCart(selVid, function () {
          t.textContent = 'Sepete eklendi ✓';
          btn.classList.add('is-done');
          closeModals();
          setTimeout(function () { t.textContent = old; btn.classList.remove('is-done'); btn.disabled = false; }, 1600);
        }, function () {
          t.textContent = old; btn.disabled = false;
        });
      });
    });

    // ── Sanal Deneme Kabini ──
    var M = { boy: 168, kilo: 58, yas: 28, gogus: 88, alt: 76, bel: 70, kalca: 96 };
    var touched = false;
    try { var sv = JSON.parse(localStorage.getItem('ff_measure')); if (sv) { Object.assign(M, sv); touched = true; } } catch (e0) {}
    var wiz = document.getElementById('ff-wizard');
    function syncInputs() {
      if (!wiz) return;
      wiz.querySelectorAll('input[data-m], input[data-mn]').forEach(function (i) {
        var k = i.getAttribute('data-m') || i.getAttribute('data-mn');
        if (M[k] != null) i.value = M[k];
      });
    }
    syncInputs();
    function goStep(n) {
      wiz.querySelectorAll('.ff-wiz__step').forEach(function (s) { s.classList.toggle('is-on', s.getAttribute('data-step') == n); });
    }
    function estimate() {
      if (touched) return;
      var k = M.kilo, b = M.boy;
      M.gogus = Math.round(Math.min(118, Math.max(72, k * 0.66 + 46 + (b - 165) * 0.1)));
      M.alt = Math.max(62, M.gogus - 12);
      M.bel = Math.round(Math.min(108, Math.max(57, k * 0.62 + 33)));
      M.kalca = Math.round(Math.min(128, Math.max(82, k * 0.6 + 60)));
      syncInputs();
    }
    if (wiz) {
      wiz.addEventListener('input', function (e) {
        var k = e.target.getAttribute('data-m') || e.target.getAttribute('data-mn');
        if (!k) return;
        var v = parseFloat(e.target.value); if (isNaN(v)) return;
        M[k] = v;
        if (['gogus', 'alt', 'bel', 'kalca'].indexOf(k) > -1) {
          touched = true;
          wiz.querySelectorAll('input[data-m="' + k + '"], input[data-mn="' + k + '"]').forEach(function (i) { if (i !== e.target) i.value = v; });
          wiz.querySelectorAll('.ff-wiz__band').forEach(function (g) { g.classList.toggle('is-live', g.getAttribute('data-band') === k); });
          wiz.querySelectorAll('[data-sl]').forEach(function (l) { l.classList.toggle('is-live', l.getAttribute('data-sl') === k); });
          var hint = wiz.querySelector('[data-hint]'); if (hint) hint.classList.add('is-off');
          var co = wiz.querySelector('[data-callout]');
          if (co) {
            var tops = { gogus: '31%', alt: '37%', bel: '46%', kalca: '57%' };
            co.hidden = false; co.style.top = tops[k];
            co.querySelector('[data-callout-txt]').textContent = BANDLBL[k] + ': ' + v + ' cm';
            co.classList.remove('is-pop'); void co.offsetWidth; co.classList.add('is-pop');
          }
        }
      });
      wiz.addEventListener('click', function (e) {
        if (e.target.closest('[data-step-next]')) { estimate(); goStep(2); }
        if (e.target.closest('[data-step-prev]')) {
          var cur = wiz.querySelector('.ff-wiz__step.is-on').getAttribute('data-step');
          goStep(cur === '3' ? 2 : 1);
        }
        if (e.target.closest('[data-step-reco]')) {
          var ld = wiz.querySelector('[data-wizload]');
          if (ld && !ld.dataset.run) {
            ld.dataset.run = '1';
            ld.hidden = false;
            var txt = ld.querySelector('[data-loadtxt]');
            txt.textContent = 'Ölçülerin analiz ediliyor…';
            ld.classList.add('is-run');
            setTimeout(function () { txt.textContent = 'Hazır!'; ld.classList.add('is-done'); }, 1050);
            setTimeout(function () {
              ld.hidden = true; ld.classList.remove('is-run', 'is-done'); delete ld.dataset.run;
              recommend(); goStep(3);
            }, 1650);
          } else if (!ld) { recommend(); goStep(3); }
        }
      });
    }
    var RANGES = {
      S: { gogus: [82, 88], alt: [68, 74], bel: [60, 68], kalca: [86, 94] },
      M: { gogus: [88, 96], alt: [74, 80], bel: [68, 76], kalca: [94, 102] },
      L: { gogus: [96, 104], alt: [80, 88], bel: [76, 84], kalca: [102, 110] }
    };
    var BANDLBL = { gogus: 'Göğüs', alt: 'Göğüs altı', bel: 'Bel', kalca: 'Kalça' };
    var bestSize = null, recoSize = null;
    function penalty(size) {
      var t = 0;
      Object.keys(RANGES[size]).forEach(function (k) {
        var r = RANGES[size][k], v = M[k];
        if (v < r[0]) t += r[0] - v; else if (v > r[1]) t += v - r[1];
      });
      return t;
    }
    // bölge bazlı uyum: 0 cm fark = yeşil, 1-4 cm = turuncu, 4+ cm = kırmızı
    function zoneFit(size) {
      return Object.keys(RANGES[size]).map(function (k) {
        var r = RANGES[size][k], v = M[k], d = 0, dir = '';
        if (v > r[1]) { d = v - r[1]; dir = 'dar'; }
        else if (v < r[0]) { d = r[0] - v; dir = 'bol'; }
        var cls = 'is-good', txt = 'tam uyum';
        if (d > 4) { cls = 'is-alert'; txt = 'çok ' + dir + ' (' + d + ' cm)'; }
        else if (d > 0) { cls = 'is-warn'; txt = 'hafif ' + dir + ' (' + d + ' cm)'; }
        return { k: k, d: d, dir: dir, cls: cls, txt: txt };
      });
    }
    function sizeStatus(s) {
      var p = penalty(s), zs = zoneFit(s), severe = p > 8, i;
      for (i = 0; i < zs.length; i++) if (zs[i].d > 4) severe = true;
      if (severe) return 'alert';
      return p === 0 ? 'good' : 'warn';
    }
    function fitPct(s) { return Math.max(40, Math.round(100 - penalty(s) * 3)); }
    function sizeVariant(s) { return P.variants.filter(function (v) { return v.title === s; })[0]; }
    function countTo(el, to) {
      var from = parseInt((el.textContent || '').replace(/\D/g, ''), 10) || 0, t0 = null;
      function fr(ts) {
        if (!t0) t0 = ts;
        var k = Math.min(1, (ts - t0) / 800);
        el.textContent = '%' + Math.round(from + (to - from) * (1 - Math.pow(1 - k, 3)));
        if (k < 1) requestAnimationFrame(fr);
      }
      requestAnimationFrame(fr);
    }
    var RING_C = 2 * Math.PI * 52;
    function applySize(s, first) {
      bestSize = s;
      var st = sizeStatus(s), uy = fitPct(s);
      var vv = sizeVariant(s), soldout = vv && !vv.available;
      var bEl = wiz.querySelector('[data-best]'); if (bEl) bEl.textContent = s;
      // skor halkası + yüzde sayacı
      var score = wiz.querySelector('[data-score]'), arc = wiz.querySelector('[data-ringarc]');
      score.classList.remove('is-good', 'is-warn', 'is-alert');
      score.classList.add('is-' + st);
      score.classList.remove('is-pop'); void score.offsetWidth; score.classList.add('is-pop');
      if (first) {
        arc.style.transition = 'none'; arc.style.strokeDashoffset = RING_C;
        void arc.getBoundingClientRect(); arc.style.transition = '';
      }
      arc.style.strokeDashoffset = RING_C * (1 - uy / 100);
      countTo(wiz.querySelector('[data-fitpct]'), uy);
      wiz.querySelector('[data-scorebadge]').textContent = st === 'good' ? '✓' : (st === 'alert' ? '!' : '~');
      // manken halkaları + lejant (bölge bazlı renk, pop animasyonu)
      var resSvg = wiz.querySelector('.ff-wiz__svg--res'), leg = [];
      zoneFit(s).forEach(function (z, i) {
        var g = resSvg.querySelector('.ff-wiz__band[data-band="' + z.k + '"]');
        g.classList.remove('is-good', 'is-warn', 'is-alert', 'is-tight', 'is-loose', 'is-pulse');
        void g.getBoundingClientRect();
        g.classList.add(z.cls, 'is-pulse');
        leg.push('<span class="' + z.cls + '" style="animation-delay:' + (i * 90) + 'ms"><i></i>' + BANDLBL[z.k] + ': ' + z.txt + '</span>');
      });
      var legEl = wiz.querySelector('[data-legend]');
      legEl.innerHTML = ''; void legEl.offsetWidth; legEl.innerHTML = leg.join('');
      // silüet tepkisi
      var stage = wiz.querySelector('[data-step="3"] .ff-wiz__stage');
      stage.classList.remove('is-warn', 'is-alert', 'is-nudge');
      if (st !== 'good') { void stage.offsetWidth; stage.classList.add('is-' + st); if (st === 'alert') stage.classList.add('is-nudge'); }
      // uyum notu
      var note = wiz.querySelector('[data-fitnote]');
      note.className = 'ff-wiz__fitnote is-' + st;
      note.textContent = 'Ölçülerine göre %' + uy + ' uyum';
      wiz.querySelector('[data-reslbl]').textContent = s === recoSize ? 'En uygun beden' : 'Seçtiğin beden';
      // uyarı bandı
      var warn = wiz.querySelector('[data-fitwarn]'), wt = wiz.querySelector('[data-fitwarn-txt]'), back = wiz.querySelector('[data-backbest]');
      var show = soldout || (s !== recoSize && st !== 'good');
      warn.hidden = !show;
      warn.className = 'ff-wiz__fitwarn';
      if (show) {
        var parts = zoneFit(s).filter(function (z) { return z.d > 0; }).map(function (z) { return BANDLBL[z.k].toLowerCase() + ' ' + (z.d > 4 ? 'çok ' : 'hafif ') + z.dir; });
        if (soldout) wt.textContent = 'Bu beden şu an tükendi.';
        else if (st === 'alert') wt.textContent = 'Bu beden ölçülerine uymuyor: ' + parts.join(', ') + '.';
        else wt.textContent = 'Küçük fark var: ' + parts.join(', ') + '.';
        back.hidden = s === recoSize;
        back.textContent = recoSize + ' bedene dön';
        void warn.offsetWidth;
        warn.classList.add('is-in', (soldout || st === 'alert') ? 'is-alert' : 'is-warn');
      }
      wiz.querySelector('[data-wizadd]').disabled = !!soldout;
    }
    function recommend() {
      try { localStorage.setItem('ff_measure', JSON.stringify(M)); } catch (e1) {}
      var scores = Object.keys(RANGES).map(function (s) { return { s: s, p: penalty(s) }; }).sort(function (a, b) { return a.p - b.p; });
      recoSize = scores[0].s;
      var altsHtml = Object.keys(RANGES).map(function (s) {
        var st = sizeStatus(s), vv = sizeVariant(s), out = vv && !vv.available;
        var ic = out ? '—' : (st === 'good' ? '✓' : (st === 'alert' ? '×' : '~'));
        return '<button type="button" class="ff-wiz__alt is-' + st + (out ? ' is-out' : '') + (s === recoSize ? ' is-reco' : '') + '" data-alt="' + s + '">' +
          (s === recoSize ? '<em>Önerilen</em>' : '') + '<b>' + s + '</b><i>' + ic + '</i></button>';
      }).join('');
      var altsEl = wiz.querySelector('[data-alts]');
      altsEl.innerHTML = altsHtml;
      altsEl.querySelectorAll('[data-alt]').forEach(function (a) {
        a.addEventListener('click', function () {
          if (a.classList.contains('is-sel')) return;
          altsEl.querySelectorAll('[data-alt]').forEach(function (x) { x.classList.remove('is-sel'); });
          a.classList.add('is-sel');
          applySize(a.getAttribute('data-alt'));
        });
      });
      var recoBtn = altsEl.querySelector('[data-alt="' + recoSize + '"]');
      if (recoBtn) recoBtn.classList.add('is-sel');
      applySize(recoSize, true);
    }
    var backBtn = wiz && wiz.querySelector('[data-backbest]');
    if (backBtn) backBtn.addEventListener('click', function () {
      var c = wiz.querySelector('[data-alt="' + recoSize + '"]');
      if (c) c.click();
    });
    var wizAdd = document.querySelector('[data-wizadd]');
    if (wizAdd) wizAdd.addEventListener('click', function () {
      var v = P.variants.filter(function (x) { return x.title === bestSize; })[0];
      if (!v) return;
      if (!v.available) { ffToast('Bu beden tükendi'); return; }
      addToCart(v.id, function () { closeModals(); });
    });
    function wtab(name) {
      if (!wiz) return;
      wiz.querySelectorAll('[data-wtab]').forEach(function (b) { b.classList.toggle('is-on', b.getAttribute('data-wtab') === name); });
      wiz.querySelectorAll('[data-wpane]').forEach(function (pn) { pn.hidden = pn.getAttribute('data-wpane') !== name; });
    }
    if (wiz) wiz.querySelectorAll('[data-wtab]').forEach(function (b) {
      b.addEventListener('click', function () { wtab(b.getAttribute('data-wtab')); });
    });

    // ── Öneri rayları + set çekmecesi ──
    function miniCard(pr) {
      var img = (pr.images && pr.images[0]) || pr.featured_image || '';
      img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=600';
      var sizes = (pr.variants || []).map(function (v) {
        return '<button type="button" class="ff-qa__size' + (v.available ? '' : ' is-out') + '" data-id="' + v.id + '"' + (v.available ? '' : ' disabled') + '>' + esc(v.title) + '</button>';
      }).join('');
      return '<div class="ff-mini ff-qa">' +
        '<div class="ff-mini__media"><a href="/products/' + pr.handle + '"><img src="' + img + '" alt="' + esc(pr.title) + '" loading="lazy"></a>' +
        '<button class="ff-qa__btn" type="button" aria-label="Hızlı ekle">+</button></div>' +
        '<div class="ff-qa__pop"><div class="ff-qa__top"><span class="ff-qa__name">' + esc(pr.title) + '</span><button class="ff-qa__x" type="button" aria-label="Kapat">×</button></div>' +
        '<p class="ff-qa__lbl">Beden seç</p><div class="ff-qa__sizes">' + sizes + '</div><p class="ff-qa__note">✦ Sınırlı sayıda</p></div>' +
        '<div class="ff-mini__i"><a href="/products/' + pr.handle + '">' + esc(pr.title) + '</a><span>' + fmt(pr.price) + '</span></div></div>';
    }
    function fillRail(el, prods) { el.innerHTML = prods.map(miniCard).join(''); quickAdd(); }
    function fetchByHandles(handles, cb) {
      Promise.all(handles.map(function (h) {
        return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
      })).then(function (list) { cb(list.filter(Boolean)); });
    }
    function recosHandles(cb) {
      function fallback() {
        fetch('/products.json?limit=12').then(function (r) { return r.json(); }).then(function (d) {
          cb((d.products || []).map(function (x) { return x.handle; }).filter(function (h) { return h !== P.handle; }));
        }).catch(function () { cb([]); });
      }
      fetch('/recommendations/products.json?product_id=' + P.id + '&limit=8')
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var hs = (d.products || []).map(function (x) { return x.handle; }).filter(function (h) { return h !== P.handle; });
          if (hs.length) cb(hs); else fallback();
        }).catch(fallback);
    }
    var setH = (root.getAttribute('data-set') || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    var rail = document.querySelector('[data-rail]');
    if (rail) {
      if (setH.length) fetchByHandles(setH, function (ps) { ps.length ? fillRail(rail, ps) : recosHandles(function (hs) { fetchByHandles(hs.slice(0, 6), function (p2) { fillRail(rail, p2); }); }); });
      else recosHandles(function (hs) { fetchByHandles(hs.slice(0, 6), function (ps) { fillRail(rail, ps); }); });
    }
    var setlist = document.querySelector('[data-setlist]');
    if (setlist && setH.length) fetchByHandles(setH, function (ps) {
      setlist.innerHTML = ps.map(function (pr) {
        var img = ((pr.images && pr.images[0]) || '') ; img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=400';
        var sizes = (pr.variants || []).map(function (v) {
          return '<button type="button" class="ff-qa__size' + (v.available ? '' : ' is-out') + '" data-id="' + v.id + '"' + (v.available ? '' : ' disabled') + '>' + esc(v.title) + '</button>';
        }).join('');
        return '<div class="ff-drawer__item ff-qa"><img src="' + img + '" alt="' + esc(pr.title) + '"><div class="ff-drawer__meta">' +
          '<a href="/products/' + pr.handle + '">' + esc(pr.title) + '</a><span>' + fmt(pr.price) + '</span>' +
          '<div class="ff-qa__sizes">' + sizes + '</div></div></div>';
      }).join('');
      quickAdd();
    });
  }

  // "Bunları da beğenebilirsiniz" — alt öneri bölümü
  function recosSection() {
    var sec = document.querySelector('.ff-recos');
    if (!sec || sec.dataset.done) return;
    sec.dataset.done = '1';
    var box = sec.querySelector('[data-recos]');
    var pid = sec.getAttribute('data-pid'), ph = sec.getAttribute('data-phandle');
    function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    function fmt(cents) { return (cents / 100).toLocaleString('tr-TR', { minimumFractionDigits: 2 }) + ' TL'; }
    function render(list) {
      box.innerHTML = list.map(function (pr) {
        var img = (pr.images && pr.images[0]) || ''; img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=600';
        var sizes = (pr.variants || []).map(function (v) {
          return '<button type="button" class="ff-qa__size' + (v.available ? '' : ' is-out') + '" data-id="' + v.id + '"' + (v.available ? '' : ' disabled') + '>' + esc(v.title) + '</button>';
        }).join('');
        return '<div class="ff-mini ff-qa">' +
          '<div class="ff-mini__media"><a href="/products/' + pr.handle + '"><img src="' + img + '" alt="' + esc(pr.title) + '" loading="lazy"></a>' +
          '<button class="ff-qa__btn" type="button" aria-label="Hızlı ekle">+</button></div>' +
          '<div class="ff-qa__pop"><div class="ff-qa__top"><span class="ff-qa__name">' + esc(pr.title) + '</span><button class="ff-qa__x" type="button" aria-label="Kapat">×</button></div>' +
          '<p class="ff-qa__lbl">Beden seç</p><div class="ff-qa__sizes">' + sizes + '</div><p class="ff-qa__note">✦ Sınırlı sayıda</p></div>' +
          '<div class="ff-mini__i"><a href="/products/' + pr.handle + '">' + esc(pr.title) + '</a><span>' + fmt(pr.price) + '</span></div></div>';
      }).join('');
      quickAdd();
    }
    function byHandles(hs) {
      Promise.all(hs.map(function (h) { return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }); }))
        .then(function (l) { render(l.filter(Boolean)); });
    }
    function fallback() {
      fetch('/products.json?limit=12').then(function (r) { return r.json(); }).then(function (d) {
        byHandles((d.products || []).map(function (x) { return x.handle; }).filter(function (h) { return h !== ph; }).slice(0, 8));
      }).catch(function () {});
    }
    fetch('/recommendations/products.json?product_id=' + pid + '&limit=8')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var hs = (d.products || []).map(function (x) { return x.handle; }).filter(function (h) { return h !== ph; });
        if (hs.length) byHandles(hs.slice(0, 8)); else fallback();
      }).catch(fallback);
  }

  // Footer: düşen beyaz güller (footer görünürken oynar)
  function footRoses() {
    var foot = document.querySelector('.ff-foot');
    if (!foot || foot.querySelector('.ff-foot__roses')) return;
    var wrap = document.createElement('div');
    wrap.className = 'ff-foot__roses';
    wrap.setAttribute('aria-hidden', 'true');
    var mobile = window.innerWidth < 750;
    var count = mobile ? 22 : 40;
    for (var i = 0; i < count; i++) {
      var r = document.createElement('span');
      r.textContent = '❀';
      r.style.left = (Math.random() * 99) + '%';
      r.style.fontSize = (mobile ? 9 + Math.random() * 12 : 11 + Math.random() * 15) + 'px';
      r.style.setProperty('--o', (0.35 + Math.random() * 0.45).toFixed(2));
      r.style.setProperty('--sway', ((Math.random() * (mobile ? 8 : 4) - (mobile ? 4 : 2)).toFixed(1)) + 'vw');
      r.style.setProperty('--spin', Math.round(90 + Math.random() * 180) * (Math.random() < 0.5 ? -1 : 1) + 'deg');
      r.style.animationDuration = (7 + Math.random() * 8).toFixed(1) + 's';
      r.style.animationDelay = (-Math.random() * 15).toFixed(1) + 's';
      wrap.appendChild(r);
    }
    function setFall() { wrap.style.setProperty('--fall', foot.offsetHeight + 'px'); }
    setFall();
    window.addEventListener('resize', setFall);
    foot.appendChild(wrap);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { foot.classList.toggle('is-live', e.isIntersecting); });
      }, { rootMargin: '80px' }).observe(foot);
    } else { foot.classList.add('is-live'); }
  }

  // Hızlı Satın Al: varyantı sepete ekle → sepete yönlendir
  function quickBuy() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-quickbuy]');
      if (!btn) return;
      e.preventDefault(); e.stopPropagation();
      if (btn.classList.contains('is-adding')) return;
      btn.classList.add('is-adding');
      var txtEl = btn.querySelector('[data-qb-label]') || btn;
      var label = txtEl.textContent; txtEl.textContent = 'Ekleniyor…';
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: parseInt(btn.getAttribute('data-quickbuy'), 10), quantity: 1 }] }) })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () { window.location.href = '/cart'; })
        .catch(function () { btn.classList.remove('is-adding'); txtEl.textContent = label; ffToast('Eklenemedi, tekrar dene'); });
    }, true);
  }

  // Kategori dairesi videoları: görünür olanı oynat, olmayanı duraklat (eşzamanlı oynatma limitini aş)
  function catVideos() {
    var vids = document.querySelectorAll('.ff-story-item__img video');
    if (!vids.length) return;
    function play(v) { v.muted = true; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    vids.forEach(function (v) {
      if (v.dataset.cv) return; v.dataset.cv = '1';
      v.muted = true; v.setAttribute('playsinline', ''); v.setAttribute('muted', '');
      v.addEventListener('canplay', function () { play(v); });
      v.addEventListener('loadeddata', function () { play(v); });
      play(v);
    });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (ents) {
        ents.forEach(function (e) { if (e.isIntersecting) { play(e.target); } else { e.target.pause(); } });
      }, { threshold: 0.2 });
      vids.forEach(function (v) { io.observe(v); });
    }
    // sayfa görünür olunca tekrar dene (sekme değişimi vb.)
    document.addEventListener('visibilitychange', function () { if (!document.hidden) vids.forEach(play); });
  }

  // Kategoriler bölümünde yukarıdan aşağı düşen kıyafet emojileri
  function emojiRain() {
    var sec = document.querySelector('.ff-stories');
    if (!sec || sec.dataset.rain) return; sec.dataset.rain = '1';
    var wrap = document.createElement('div'); wrap.className = 'ff-emoji-rain';
    sec.insertBefore(wrap, sec.firstChild);
    var emo = ['👗', '👙', '🩱', '👠', '💄', '🧥', '👛', '🥿', '🩰', '💋'];
    var running = true;
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { running = en[0].isIntersecting; }, { threshold: 0 }).observe(sec);
    }
    setInterval(function () {
      if (!running || document.hidden) return;
      var i = document.createElement('i');
      i.textContent = emo[Math.floor(Math.random() * emo.length)];
      i.style.left = Math.random() * 97 + '%';
      i.style.fontSize = (1.1 + Math.random() * 1.3) + 'rem';
      var dur = 4 + Math.random() * 4;
      i.style.animationDuration = dur + 's';
      wrap.appendChild(i);
      setTimeout(function () { if (i.parentNode) i.parentNode.removeChild(i); }, dur * 1000 + 300);
    }, 520);
  }

  // ── Sepet sayfası: adet değiştir / sil / indirim kodu ──
  function cartPage() {
    var root = document.querySelector('.ff-cart');
    if (!root) return;
    function change(card, qty) {
      card.classList.add('is-busy');
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: parseInt(card.getAttribute('data-line'), 10), quantity: qty })
      }).then(function (r) { return r.json(); }).then(function () { location.reload(); })
        .catch(function () { card.classList.remove('is-busy'); ffToast('Bir sorun oluştu, tekrar dene'); });
    }
    root.addEventListener('click', function (e) {
      var card = e.target.closest('[data-citem]');
      if (card) {
        var q = parseInt(card.querySelector('[data-cqty]').textContent, 10);
        if (e.target.closest('[data-cplus]')) change(card, q + 1);
        else if (e.target.closest('[data-cminus]')) change(card, Math.max(0, q - 1));
        else if (e.target.closest('[data-cdel]')) change(card, 0);
      }
      if (e.target.closest('[data-dcapply]')) {
        var inp = root.querySelector('[data-dcode]'), msg = root.querySelector('[data-dcmsg]');
        var code = (inp.value || '').trim();
        if (!code) return;
        fetch('/discount/' + encodeURIComponent(code)).then(function () {
          msg.hidden = false;
          msg.textContent = '"' + code + '" kodu kaydedildi — ödeme adımında otomatik uygulanacak.';
        });
      }
    });
  }

  // Arama barını header'a (logonun yanına) taşı
  // Boş aramayla /search'e gitmeyi engelle
  function searchGuard() {
    document.querySelectorAll('form.ff-search, form.ff-searchpg__form').forEach(function (f) {
      if (f.dataset.sg) return; f.dataset.sg = '1';
      f.addEventListener('submit', function (e) {
        var q = f.querySelector('input[name="q"]');
        if (!q || !q.value.trim()) { e.preventDefault(); if (q) q.focus(); }
      });
    });
  }

  function moveSearch() {
    var s = document.querySelector('.ff-search');
    var icons = document.querySelector('.header__icons');
    if (s && icons && !s.dataset.moved) {
      s.dataset.moved = '1';
      icons.insertBefore(s, icons.firstChild);
      s.classList.add('ff-search--header');
    }
  }

  // Video oynatma yöneticisi: video yalnızca ekranda görünürken oynar.
  // Mobil tarayıcılar sınırlı sayıda eşzamanlı videoya izin verdiğinden,
  // görünmeyenleri duraklatmak görünenlerin oynamasını garanti eder.
  function videoManager() {
    var vids = [].slice.call(document.querySelectorAll('video[autoplay]'));
    if (!vids.length) return;
    // Ekran dışı videolar hiç indirilmesin: kaynak data-vsrc'te bekler,
    // ilk kez görünür olduğunda atanır. (Sayfa açılışında mobilde ~2.8MB tasarruf.)
    function ensureSrc(v) {
      var lazy = v.getAttribute('data-vsrc');
      if (lazy && !v.getAttribute('src')) { v.setAttribute('src', lazy); v.load(); }
    }
    function tryPlay(v) {
      // Açık hotspot kartı: visibility geçişi sürerken checkVisibility yanlış negatif verir
      var inOpenSpot = v.closest && v.closest('.ff-hotspot.is-open');
      if (!inOpenSpot && v.checkVisibility && !v.checkVisibility({ checkVisibilityCSS: true })) { if (!v.paused) v.pause(); return; }
      ensureSrc(v);
      v.muted = true;
      v.playsInline = true;
      if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    }
    if (!('IntersectionObserver' in window)) { vids.forEach(tryPlay); return; }
    if (window.__ffVidIO) window.__ffVidIO.disconnect();
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) { v.dataset.ffInView = '1'; tryPlay(v); }
        else { delete v.dataset.ffInView; if (!v.paused) v.pause(); }
      });
    }, { rootMargin: '20% 0px 20% 0px', threshold: 0.01 });
    vids.forEach(function (v) {
      io.observe(v);
      if (!v.dataset.ffPlayGuard) {
        v.dataset.ffPlayGuard = '1';
        // Tarayıcı autoplay'i IO'dan bağımsız başlatabilir; kural dışı başlayanı durdur
        v.addEventListener('playing', function () {
          if (v.closest && v.closest('.ff-hotspot.is-open')) return;
          var hidden = v.checkVisibility && !v.checkVisibility({ checkVisibilityCSS: true });
          if (hidden || !v.dataset.ffInView) v.pause();
        });
      }
    });
    window.__ffVidIO = io;
    if (!window.__ffVidKick) {
      window.__ffVidKick = true;
      var kick = function () {
        document.querySelectorAll('video[autoplay]').forEach(function (v) {
          if (v.dataset.ffInView) tryPlay(v);
        });
      };
      ['touchstart', 'click'].forEach(function (ev) { document.addEventListener(ev, kick, { passive: true }); });
      document.addEventListener('visibilitychange', function () { if (!document.hidden) kick(); });
    }
  }

  /* Gece indirimi şeridi — pencere Türkiye saatiyle hesaplanır,
     ziyaretçinin cihaz saat dilimi ne olursa olsun aynı sonucu verir. */
  function nightDeal() {
    var el = document.querySelector('[data-nightdeal]');
    if (!el) return;

    var startH = parseInt(el.dataset.start, 10);
    var endH = parseInt(el.dataset.end, 10);
    if (isNaN(startH) || isNaN(endH)) return;

    var teaser = el.dataset.teaser === '1';
    var lead = parseInt(el.dataset.teaserLead, 10) || 0;
    var titleEl = el.querySelector('[data-nighttitle]');
    var labelEl = el.querySelector('[data-nightclocklabel]');
    var timeEl = el.querySelector('[data-nighttimer]');
    var subEl = el.querySelector('[data-nightsub]');
    var subText = subEl ? subEl.textContent : '';

    /* Pencerenin BAŞLAYABİLECEĞİ günler (0 Pazar … 6 Cumartesi). Boşsa her gün.
       Gece aşırı pencerede sabah kısmı önceki günün hakkıdır: "1,2,3,4,5" →
       Cuma 21:00 → Cumartesi 06:00 dahil, Cumartesi/Pazar akşamı yok.
       Shopify'daki gerçek indirim (Gece İndirimi fonksiyonu) aynı kuralı uygular. */
    var days = (el.dataset.days || '').split(',').map(function (d) { return parseInt(d, 10); })
      .filter(function (d) { return d >= 0 && d <= 6; });
    var WD = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
    function dayOk(d) { return !days.length || days.indexOf((d + 7) % 7) !== -1; }

    var fmt, stampFmt, wdFmt;
    try {
      fmt = new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/Istanbul', hour12: false,
        hour: '2-digit', minute: '2-digit', second: '2-digit'
      });
      wdFmt = new Intl.DateTimeFormat('en-US', { timeZone: 'Europe/Istanbul', weekday: 'short' });
      stampFmt = new Intl.DateTimeFormat('en-CA', {
        timeZone: 'Europe/Istanbul', hour12: false,
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit'
      });
    } catch (e) { return; }

    /* Kampanya tarih aralığı — "YYYY-AA-GG SS:DD" metinleri ISO sırasında
       olduğu için düz string karşılaştırması doğru sonuç verir. */
    function trStamp() {
      var parts = stampFmt.formatToParts(new Date());
      var o = {};
      for (var i = 0; i < parts.length; i++) o[parts[i].type] = parts[i].value;
      return o.year + '-' + o.month + '-' + o.day + ' ' + (parseInt(o.hour, 10) % 24 + 100 + '').slice(1) + ':' + o.minute;
    }
    function norm(s) { return (s || '').trim().replace('T', ' '); }
    var from = norm(el.dataset.from);
    var until = norm(el.dataset.until);

    function trSeconds() {
      var parts = fmt.formatToParts(new Date());
      var o = {};
      for (var i = 0; i < parts.length; i++) o[parts[i].type] = parts[i].value;
      // Bazı motorlar gece yarısı için "24" döndürür → %24 ile normalize et
      var h = parseInt(o.hour, 10) % 24;
      return h * 3600 + parseInt(o.minute, 10) * 60 + parseInt(o.second, 10);
    }

    function pad(n) { return (n < 10 ? '0' : '') + n; }

    /* Kampanya aktifken <html>'e .ff-night-on eklenir — ürün kartlarındaki
       gece rozetleri (.ff-cg__deal--night) buna bakarak görünür/gizlenir. */
    function setRoot(active) {
      document.documentElement.classList.toggle('ff-night-on', !!active);
    }

    /* ÖNİZLEME: ?gece=1 kampanyayı zorla açar, ?gece=0 zorla kapatır.
       Sekme boyunca hatırlanır (sessionStorage) — sayfalar arası gezerken kaybolmaz.
       ?gece=x ile temizlenir. Ziyaretçiyi etkilemez, sadece linki bilen görür. */
    var force = null;
    try {
      var q = new URLSearchParams(window.location.search).get('gece');
      if (q === '1' || q === '0') { sessionStorage.setItem('ffNightPreview', q); force = q; }
      else if (q !== null) { sessionStorage.removeItem('ffNightPreview'); }
      else { force = sessionStorage.getItem('ffNightPreview'); }
    } catch (e) {}

    function tick() {
      if (force === '0') { el.classList.remove('is-on', 'is-pre'); setRoot(false); return; }
      if (force === '1') {
        el.classList.add('is-on');
        el.classList.remove('is-pre');
        setRoot(true);
        var t = trSeconds(), sf = startH * 3600, ef = endH * 3600;
        var rf = sf > ef ? (t >= sf ? (86400 - t) + ef : (t < ef ? ef - t : (86400 - t) + ef)) : ef - t;
        if (rf < 0) rf += 86400;
        if (timeEl) timeEl.textContent = pad(Math.floor(rf / 3600)) + ':' + pad(Math.floor((rf % 3600) / 60)) + ':' + pad(rf % 60);
        if (titleEl) titleEl.textContent = el.dataset.titleOn || '';
        if (labelEl) labelEl.textContent = el.dataset.labelOn || '';
        if (subEl) subEl.textContent = subText;
        return;
      }
      if (from || until) {
        var stamp = trStamp();
        if ((from && stamp < from) || (until && stamp > until)) {
          el.classList.remove('is-on', 'is-pre');
          setRoot(false);
          return;
        }
      }
      var now = trSeconds();
      var s = startH * 3600;
      var e = endH * 3600;
      var DAY = 86400;
      var on, remain;

      var today = WD[wdFmt.format(new Date())];

      if (s === e) {                     // tüm gün (başlangıç = bitiş) — sayaç kampanya bitişine
        on = dayOk(today);
        remain = DAY - now;
        if (until) {
          var endMs = Date.parse(until.replace(' ', 'T') + ':00+03:00');
          if (!isNaN(endMs)) remain = Math.max(0, Math.floor((endMs - Date.now()) / 1000) + 60);
        }
      } else if (s > e) {                // gece aşırı pencere (21:00 → 09:00)
        on = (now >= s && dayOk(today)) || (now < e && dayOk(today - 1));
        remain = now >= s ? (DAY - now) + e : e - now;
      } else {                           // aynı gün içinde
        on = now >= s && now < e && dayOk(today);
        remain = e - now;
      }

      var toStart = s - now;             // başlamasına kalan
      if (toStart < 0) toStart += DAY;
      var startDay = now < s ? today : today + 1;
      var pre = !on && teaser && toStart <= lead * 3600 && dayOk(startDay);

      el.classList.toggle('is-on', on || pre);
      el.classList.toggle('is-pre', pre);
      setRoot(on);
      if (!on && !pre) return;

      var left = on ? remain : toStart;
      if (timeEl) {
        var dd = Math.floor(left / DAY);
        left = left % DAY;
        timeEl.textContent = (dd ? dd + 'g ' : '') + pad(Math.floor(left / 3600)) + ':' +
          pad(Math.floor((left % 3600) / 60)) + ':' + pad(left % 60);
      }
      if (titleEl) titleEl.textContent = pre ? (el.dataset.titlePre || '') : (el.dataset.titleOn || '');
      if (labelEl) labelEl.textContent = pre ? (el.dataset.labelPre || '') : (el.dataset.labelOn || '');
      if (subEl) subEl.textContent = pre ? '' : subText;
    }

    tick();
    if (window.__ffNightTimer) clearInterval(window.__ffNightTimer);
    window.__ffNightTimer = setInterval(tick, 1000);
  }

  // Her yenilemede sayfa en üstten başlasın
  if ('scrollRestoration' in history) { try { history.scrollRestoration = 'manual'; } catch (e) {} }
  function toTop() { window.scrollTo(0, 0); }


  // Kampanya iniş sayfası: beden çipleri + sepete ekle + mobil sabit çubuk
  function landing() {
    var root = document.querySelector('[data-lp]');
    if (!root || root.dataset.lpBound) return;
    root.dataset.lpBound = '1';

    var sizeBtns = [].slice.call(root.querySelectorAll('[data-sizes] .ff-size'));
    var addBtn = root.querySelector('[data-sizeadd]');
    var selVid = addBtn ? addBtn.getAttribute('data-vid') : null;

    sizeBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.disabled) return;
        selVid = b.getAttribute('data-vid');
        sizeBtns.forEach(function (x) { x.classList.toggle('is-sel', x === b); });
        if (addBtn) addBtn.disabled = false;
      });
    });

    function ekle() {
      if (!selVid) {
        // beden seçilmemişse çipleri hatırlat
        var wrap = root.querySelector('[data-sizes]');
        if (wrap) { wrap.classList.remove('is-ask'); void wrap.offsetWidth; wrap.classList.add('is-ask'); }
        return;
      }
      var t = addBtn.querySelector('[data-addtxt]') || addBtn;
      var eski = t.textContent;
      addBtn.disabled = true;
      t.textContent = 'Ekleniyor…';
      fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(selVid, 10), quantity: 1 }] })
      }).then(function (r) {
        if (!r.ok) throw new Error('ekleme başarısız');
        t.textContent = 'Sepete eklendi ✓';
        addBtn.classList.add('is-done');
        setTimeout(function () { window.location.href = '/cart'; }, 700);
      }).catch(function () {
        t.textContent = eski; addBtn.disabled = false;
      });
    }
    if (addBtn) addBtn.addEventListener('click', ekle);

    // "Sepete Ekle" kısayolları (kapanış + sabit çubuk) satın alma alanına götürür
    document.querySelectorAll('[data-lpjump]').forEach(function (j) {
      j.addEventListener('click', function (e) {
        e.preventDefault();
        root.scrollIntoView({ behavior: 'smooth', block: 'center' });
        var wrap = root.querySelector('[data-sizes]');
        if (wrap && !selVid) setTimeout(function () { wrap.classList.remove('is-ask'); void wrap.offsetWidth; wrap.classList.add('is-ask'); }, 500);
      });
    });

    // beden bulucu: ölçülerden S/M/L öner, seçili hale getir
    (function () {
      var aç = root.querySelector('[data-lpfindtoggle]');
      var panel = root.querySelector('[data-lpfind]');
      var git = root.querySelector('[data-lpfindgo]');
      var res = root.querySelector('[data-lpfindres]');
      if (!aç || !panel || !git || !res) return;

      aç.addEventListener('click', function () {
        var açık = panel.hasAttribute('hidden');
        if (açık) panel.removeAttribute('hidden'); else panel.setAttribute('hidden', '');
        aç.setAttribute('aria-expanded', açık ? 'true' : 'false');
        aç.classList.toggle('is-open', açık);
      });

      // Beden merkezleri (göğüs, bel, kalça cm)
      var TABLO = { S: [86.5, 65.5, 91.5], M: [92, 71, 97], L: [98, 77, 103] };
      var AGIRLIK = [1, 1.2, 1.2];

      function sayı(sel) {
        var el = panel.querySelector('[data-f="' + sel + '"]');
        var v = el ? parseFloat(el.value) : NaN;
        return isNaN(v) ? null : v;
      }

      function ölçüler() {
        var g = sayı('gogus'), b = sayı('bel'), k = sayı('kalca');
        if (g && b && k) return { g: g, b: b, k: k, tahmin: false };
        var boy = sayı('boy') || 168, kilo = sayı('kilo') || 58;
        // PDP sihirbazıyla aynı tahmin formülü
        return {
          g: g || Math.round(Math.min(118, Math.max(72, kilo * 0.66 + 46 + (boy - 165) * 0.1))),
          b: b || Math.round(Math.min(108, Math.max(57, kilo * 0.62 + 33))),
          k: k || Math.round(Math.min(128, Math.max(82, kilo * 0.6 + 60))),
          tahmin: true
        };
      }

      function çipBul(harf) {
        for (var i = 0; i < sizeBtns.length; i++) {
          if (sizeBtns[i].textContent.trim().toUpperCase() === harf) return sizeBtns[i];
        }
        return null;
      }

      git.addEventListener('click', function () {
        var o = ölçüler();
        var sıra = Object.keys(TABLO).map(function (harf) {
          var t = TABLO[harf];
          var d = Math.abs(o.g - t[0]) * AGIRLIK[0] + Math.abs(o.b - t[1]) * AGIRLIK[1] + Math.abs(o.k - t[2]) * AGIRLIK[2];
          return { harf: harf, fark: d, çip: çipBul(harf) };
        }).sort(function (x, y) { return x.fark - y.fark; });

        // Sınırda kalıyorsa büyük bedeni tercih et — iç giyimde dar beden iadeyi artırır
        if (sıra.length > 1 && Math.abs(sıra[0].fark - sıra[1].fark) < 2.5) {
          var düzen = ["S", "M", "L"];
          if (düzen.indexOf(sıra[1].harf) > düzen.indexOf(sıra[0].harf)) sıra = [sıra[1], sıra[0]].concat(sıra.slice(2));
        }
        var en = sıra[0];
        var stokta = sıra.filter(function (x) { return x.çip && !x.çip.disabled; });
        var seçilecek = (en.çip && !en.çip.disabled) ? en : (stokta[0] || null);
        if (!seçilecek) { res.hidden = false; res.innerHTML = '<p class="ff-lp__fnote">Şu an tüm bedenler tükendi.</p>'; return; }

        var uyari = (seçilecek.harf !== en.harf)
          ? '<p class="ff-lp__fnote">Ölçülerine en yakın beden <b>' + en.harf + '</b> ama şu an tükendi — en yakın stoktaki beden <b>' + seçilecek.harf + '</b>.</p>'
          : '';
        var kaynak = o.tahmin
          ? 'Boy ve kilona göre tahmini ölçülerin: göğüs <b>' + o.g + '</b> · bel <b>' + o.b + '</b> · kalça <b>' + o.k + '</b> cm.'
          : 'Girdiğin ölçüler: göğüs <b>' + o.g + '</b> · bel <b>' + o.b + '</b> · kalça <b>' + o.k + '</b> cm.';

        res.hidden = false;
        res.innerHTML =
          '<div class="ff-lp__fcard">' +
            '<span class="ff-lp__fsize">' + seçilecek.harf + '</span>' +
            '<div class="ff-lp__ftext"><b>Sana ' + seçilecek.harf + ' beden öneriyoruz.</b><p>' + kaynak + '</p></div>' +
          '</div>' + uyari +
          '<button type="button" class="ff-lp__fpick" data-lpfindpick>' + seçilecek.harf + ' bedenini seç</button>';

        var pick = res.querySelector('[data-lpfindpick]');
        pick.addEventListener('click', function () {
          seçilecek.çip.click();
          seçilecek.çip.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      });
    })();
    // Sabit çubuk: hero satın alma alanı ekrandan çıkınca görünür
    var stick = document.querySelector('[data-lpstick]');
    if (stick && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          var goster = !e.isIntersecting && e.boundingClientRect.top < 0;
          stick.classList.toggle('is-on', goster);
          stick.setAttribute('aria-hidden', goster ? 'false' : 'true');
        });
      }, { threshold: 0 });
      io.observe(root);
    }
  }

  // Mobilde dikey hero videosu: bandı videonun kendi oranına göre kur,
  // yoksa geniş video dar ekranda aşırı kırpılıyor.
  function videoBandRatio() {
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    document.querySelectorAll('.ff-videoband .ff-videoband__vid').forEach(function (v) {
      var band = v.closest('.ff-videoband');
      if (!band || band.dataset.ratioSet) return;
      var mod = v.getAttribute('data-mobratio') || 'auto';
      if (mod === 'band') return;
      var sabit = { '916': 9 / 16, '23': 2 / 3, '45': 4 / 5 }[mod];
      function uygula(oran) {
        if (!oran || !isFinite(oran)) return;
        band.dataset.ratioSet = '1';
        band.style.minHeight = '0';
        band.style.aspectRatio = String(oran);
        band.classList.add('ff-videoband--ratio');
      }
      if (sabit) { uygula(sabit); return; }
      // auto: SADECE dikey/kare videolarda videonun kendi oranını al.
      // Yatay videoda oranı uygulamak bandı 170px'e düşürüyordu — onlar bant olarak kalsın.
      function autoUygula() {
        if (!v.videoWidth || !v.videoHeight) return;
        var oran = v.videoWidth / v.videoHeight;
        if (oran <= 1.1) uygula(oran);
      }
      if (v.videoWidth && v.videoHeight) { autoUygula(); return; }
      v.addEventListener('loadedmetadata', autoUygula, { once: true });
    });
  }

  // Tam ekran arama katmanı: header büyüteci açar, yazınca canlı sonuç gelir.
  function searchOverlay() {
    var ovl = document.getElementById('ff-search-overlay');
    if (!ovl || ovl.dataset.srBound) return;
    ovl.dataset.srBound = '1';

    var input = ovl.querySelector('[data-srinput]');
    var clear = ovl.querySelector('[data-srclear]');
    var varsayilan = ovl.querySelector('[data-srdefault]');
    var sonuc = ovl.querySelector('[data-srresults]');
    var bos = ovl.querySelector('[data-srempty]');
    var baslik = ovl.querySelector('[data-srmaintitle]');
    var varsayilanBaslik = baslik ? baslik.textContent : '';

    function ac() {
      ovl.classList.add('is-open');
      ovl.setAttribute('aria-hidden', 'false');
      document.body.classList.add('ff-lock');
      setTimeout(function () { if (input) input.focus(); }, 260);
    }
    function kapat() {
      ovl.classList.remove('is-open');
      ovl.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('ff-lock');
    }

    // Header'daki arama: input yerine katmanı aç
    document.addEventListener('click', function (e) {
      var tetik = e.target.closest('.ff-search--header, .ff-search__btn, [data-sropen]');
      if (tetik && !e.target.closest('#ff-search-overlay')) { e.preventDefault(); ac(); return; }
      if (e.target.closest('[data-srclose]')) { e.preventDefault(); kapat(); }
      // masaustunde popup: karartilmis arka plana tiklayinca kapat
      if (e.target === ovl) kapat();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && ovl.classList.contains('is-open')) kapat();
    });

    if (clear) clear.addEventListener('click', function () {
      input.value = ''; input.focus(); guncelle();
    });

    // Popüler kelimeye tıklayınca aramayı katmanın içinde çalıştır
    ovl.querySelectorAll('[data-srterm]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        input.value = a.getAttribute('data-srterm');
        input.focus(); guncelle();
      });
    });

    function esc(t) {
      return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
    }
    function kart(p) {
      // suggest.json: image = URL metni, featured_image = { url, alt } NESNESİ
      var img = (typeof p.image === 'string' && p.image) ||
                (p.featured_image && p.featured_image.url) || '';
      if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=600';
      var ham = (p.price != null ? p.price : p.price_min);
      var sayi = (typeof ham === 'string') ? parseFloat(ham.replace(/[^\d.]/g, '')) : (ham || 0) / 100;
      if (!isFinite(sayi)) sayi = 0;
      var fiyat = sayi.toLocaleString('tr-TR', { minimumFractionDigits: 2 }) + ' TL';
      return '<a class="ff-sr__card" href="' + p.url + '">' +
        '<span class="ff-sr__cardimg">' + (img ? '<img src="' + img + '" alt="' + esc(p.title) + '" loading="lazy">' : '') + '</span>' +
        '<b>' + esc(p.title) + '</b>' +
        '<span class="ff-sr__price">' + fiyat + '</span></a>';
    }

    var zaman = null, sonSorgu = '';
    function guncelle() {
      var q = (input.value || '').trim();
      if (clear) clear.hidden = q.length === 0;
      if (q.length < 2) {
        varsayilan.hidden = false; sonuc.hidden = true; bos.hidden = true;
        if (baslik) baslik.textContent = varsayilanBaslik;
        return;
      }
      clearTimeout(zaman);
      zaman = setTimeout(function () { ara(q); }, 220);
    }
    function ara(q) {
      if (q === sonSorgu) return;
      sonSorgu = q;
      var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product&resources[limit]=10';
      fetch(url).then(function (r) { return r.json(); }).then(function (d) {
        var urunler = (d.resources && d.resources.results && d.resources.results.products) || [];
        varsayilan.hidden = true;
        if (baslik) baslik.textContent = '"' + q + '" için sonuçlar';
        if (!urunler.length) {
          sonuc.hidden = true;
          bos.hidden = false;
          bos.textContent = '"' + q + '" için sonuç bulunamadı. Farklı bir kelime deneyebilirsin.';
          return;
        }
        bos.hidden = true;
        sonuc.hidden = false;
        sonuc.innerHTML = urunler.map(kart).join('');
      }).catch(function () {
        sonuc.hidden = true; bos.hidden = false;
        bos.textContent = 'Arama şu an yanıt vermedi, tekrar dener misin?';
      });
    }
    if (input) input.addEventListener('input', guncelle);

    // Katmandaki kutu bir <form> ve action=/search — Enter'a basınca düz arama
    // sayfasına atıyordu (tasarımı bozuk: gece indirimi düz yazı düşüyor).
    // Enter artık sayfada kalıp sonucu katmanın içinde tazeliyor.
    var srBar = ovl.querySelector('.ff-sr__bar');
    if (srBar) srBar.addEventListener('submit', function (e) { e.preventDefault(); guncelle(); });
  }

  // Style Street: sahnedeki nokta ↔ sağdaki ürün kartı
  function styleStreet() {
    document.querySelectorAll('.ff-street').forEach(function (sec) {
      if (sec.dataset.ffSs) return; sec.dataset.ffSs = '1';
      var dots = [].slice.call(sec.querySelectorAll('.ff-street__dot'));
      var cards = [].slice.call(sec.querySelectorAll('.ff-street__card'));
      var mob = window.matchMedia('(max-width: 899px)');

      function show(i) {
        dots.forEach(function (d) { d.classList.toggle('is-active', d.dataset.spot === i); });
        cards.forEach(function (c) { c.classList.toggle('is-active', c.dataset.card === i); });
        if (mob.matches) {
          var a = sec.querySelector('.ff-street__card.is-active');
          if (a) a.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }
      dots.forEach(function (d) {
        d.addEventListener('click', function () { show(d.dataset.spot); });
      });

      // beden seçimi
      sec.querySelectorAll('.ff-street__size').forEach(function (s) {
        if (s.disabled) return;
        s.addEventListener('click', function () {
          var card = s.closest('.ff-street__card');
          card.querySelectorAll('.ff-street__size').forEach(function (o) { o.classList.remove('is-sel'); });
          s.classList.add('is-sel');
          var btn = card.querySelector('[data-add]');
          if (btn) { btn.dataset.vid = s.dataset.vid; btn.disabled = false; btn.textContent = 'Sepete Ekle'; }
        });
      });

      // sepete ekle
      sec.querySelectorAll('[data-add]').forEach(function (b) {
        b.addEventListener('click', function () {
          var id = b.dataset.vid; if (!id) return;
          b.disabled = true;
          fetch('/cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] })
          })
            .then(function (r) { return r.json(); })
            .then(function () {
              b.textContent = 'Sepete eklendi ✓'; b.classList.add('is-done');
              ffToast('Sepete eklendi ✓'); updateCartCount();
              setTimeout(function () {
                b.textContent = 'Sepete Ekle'; b.classList.remove('is-done'); b.disabled = false;
              }, 1600);
            })
            .catch(function () { b.disabled = false; ffToast('Eklenemedi, tekrar dene'); });
        });
      });
    });
  }

  // Mobil anasayfa: gece indirimi şeridi header grubunun içinde ve video ÜSTÜNE
  // biniyordu. Kullanıcı isteği: videonun bitiminde dursun. Şeridi DOM'da hero
  // bölümünün hemen ardına taşıyoruz — böylece .ff-headwrap--over'ın absolute
  // bağlamından çıkıp normal akışa giriyor.
  function nightDealAfterHero() {
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    var nd = document.querySelector('[id$="__nightdeal"]');
    var hero = document.querySelector('.ff-videoband');
    if (!nd || !hero || nd.dataset.ffMoved) return;
    var heroSec = hero.closest('.shopify-section') || hero;
    if (!heroSec || !heroSec.parentNode) return;
    nd.dataset.ffMoved = '1';
    heroSec.insertAdjacentElement('afterend', nd);
  }


  // ── KESİNTİSİZ KAYAN ŞERİT ────────────────────────────────────────────────
  // Sorun: üst şerit iki gruptan oluşuyordu ve toplam genişlik ekrandan DARDI
  // (1240px < 1440px) → sağda hiç dolmayan boşluk, yani "bant bir yerde bitiyor".
  // Çözüm: grubu ekranı aşana kadar klonla, kaydırma mesafesini TEK grup genişliği
  // yap ve süreyi mesafeye göre hesapla (hız her içerikte aynı kalsın).
  function seamless(host, trackSel, groupSel, pxPerSec) {
    var track = host.querySelector(trackSel);
    if (!track) return;
    var groups = track.querySelectorAll(groupSel);
    if (!groups.length) return;
    var unit = groups[0];
    var unitW = unit.getBoundingClientRect().width;
    if (!unitW) return;
    var hostW = host.getBoundingClientRect().width || window.innerWidth;
    var need = Math.ceil(hostW / unitW) + 1;          // ekranı doldur + 1 yedek
    if (need < 2) need = 2;
    for (var i = track.querySelectorAll(groupSel).length; i < need; i++) {
      var clone = unit.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);
    }
    track.style.setProperty('--ff-shift', unitW + 'px');
    track.style.setProperty('animation-duration', (unitW / pxPerSec).toFixed(2) + 's', 'important');
  }
  // Her çağrıda yeniden ölçer, sadece eksik klonu ekler → boot / font yüklenmesi /
  // ekran döndürme sonrasında tekrar çağırmak güvenli.
  function marquees() {
    document.querySelectorAll('.ff-topstrip').forEach(function (h) {
      seamless(h, '.ff-topstrip__track', '.ff-topstrip__group', 38);
    });
    document.querySelectorAll('.ff-marquee').forEach(function (h) {
      seamless(h, '.ff-marquee__track', '.ff-marquee__group', 52);
    });
  }
  (function () {
    var t;
    window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(marquees, 250); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(marquees).catch(function () {});
    window.addEventListener('load', marquees);
  })();

  function boot() { toTop(); init(); hotspots(); sliders(); prows(); typeSearch(); photoScrub(); quickAdd(); quickBuy(); collGrid(); pdp(); recosSection(); footRoses(); catVideos(); emojiRain(); moveSearch(); cartPage(); videoManager(); searchGuard(); nightDeal(); landing(); videoBandRatio(); searchOverlay(); styleStreet(); nightDealAfterHero(); marquees(); }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  window.addEventListener('load', toTop);
  window.addEventListener('pageshow', toTop);
  document.addEventListener('click', closeAll);
  document.addEventListener('shopify:section:load', boot);
})();
